import classes from "./Cards.module.scss";
import Image from './../Image/Image';

function Cards(props) {
  return (
    <div className={classes.Cards + " " + (props.customClass ? props.customClass : "")}>
      <div className={classes.CardsWrap}>
      { props.number ? <div className={classes.Cards__number + " " + (props.customNumClass ?  props.customNumClass : "")}>{props.number}</div> : ""}
    
      {/* CARDS TITLE  */}
        {props.title ?
          <h3 className={classes.Cards__title + " " + (props.customTitleClass ?  props.customTitleClass : "")}>
            {props.title}
          </h3>
          :
          ""
        }
      {/* CARDS TITLE  END */}

      </div>


      {/* CARDS TEXT  */}
      {
        props.text ? 
        <p className={classes.Cards__text + " " + (props.customClassText || "")}>{props.text}</p> 
        :
        ""
      }
      {/* CARDS TEXT END */}

      {
        props.src ? 
          <Image src={props.src} srcWebp={props.srcWebp}/>
          :
          ""
      }
    </div>
  )
}

export default Cards;